"use client";

import TextFieldComp from "@/app/components/appcomponents/TextFieldComp";
import { memoryPageLabel } from "./orderConfig";

/**
 * "Spominska stran: Ime Priimek, Kraj" (read-only). On a phone the design puts the words "Spominska stran:"
 * above the field and only the name in it; `mobileLabel={false}` leaves the words out there (candle popup).
 */
export default function MemoryPageField({ obituary, mobileLabel = true }) {
  const label = memoryPageLabel(obituary);
  return (
    <>
      <div className="mobile:hidden">
        <TextFieldComp value={`Spominska stran: ${label}`} readOnly background="#E8EBF0" />
      </div>
      <div className="hidden mobile:block">
        {mobileLabel && <p className="text-[16px] leading-[24px] text-[#1E2125]">Spominska stran:</p>}
        <TextFieldComp value={label} readOnly background="#E8EBF0" />
      </div>
    </>
  );
}
